import React from 'react';

const TextInput = ({ label, placeholder, fontSize, register, error }) => {
  const _fontSize = fontSize || 'text-base';
  return (
    <>
      <label className={`block mb-1 ${_fontSize} font-medium text-gray-900 text-left`}>
        {label}
      </label>
      <input
        type="text"
        className={`border border-gray-300 text-gray-900 ${_fontSize} rounded-lg focus:ring-blue-300 focus:border-blue-300 block w-full p-2.5`}
        placeholder={placeholder}
        {...register}
      />
      {error && <p className="text-red-500 text-left mt-1">{error.message}</p>}
    </>
  );
};

export default TextInput;
